import PageLayout from '@/components/feature/PageLayout';
import Seo from '@/components/feature/Seo';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import ReferencesSection from './components/ReferencesSection';
import FaqSection from './components/FaqSection';
import SeoArticle from './components/SeoArticle';
import CtaBanner from './components/CtaBanner';

export default function HomePage() {
  return (
    <PageLayout>
      <Seo
        title="İzmirde Tenteci | İzmir Tente, Pergola ve Branda Sistemleri"
        description="İzmir'de profesyonel tente, pergola ve branda sistemleri. Kasetli tente, bioklimatik pergola, zip perde ve daha fazlası. Ücretsiz keşif: 0 (536) 277 17 09"
        keywords="İzmir tente, pergola İzmir, tente firması İzmir"
        canonical="https://www.izmirdetenteci.com/"
      />
      <HeroSection />
      <ServicesSection />
      <WhyUsSection />
      <ReferencesSection />
      <FaqSection />
      <SeoArticle />
      <CtaBanner />
    </PageLayout>
  );
}
